'use strict';

module.exports = string => {
    /*Mobile menu bahavior*/
    const $menu = $('.header-menu');
    let $menuBtn = $('.header-menu__burger');
    let $menuItems = $('.header-menu .menu-item');
    let $body = $('body');
    let $overlay = $('.menu-overlay');

    $menuBtn.on('click', function (e) {
        e.preventDefault();


        if ($(window).width() <= 1200) {
            this.classList.toggle('close');
            $overlay.toggleClass('active');
            $menu.toggleClass('active');
            $body.toggleClass('menu-open');

        }
    });
    $menuItems.on('click', function () {
        if ($(window).width() <= 1200) {
            $menu.removeClass('active');
            $menuBtn.removeClass('close');
            $body.removeClass('menu-open');
            $overlay.removeClass('active');
        }
    });

    $(window).on('resize', function () {
        $menu.removeClass('active');
        $menuBtn.removeClass('close');
        $body.removeClass('menu-open');
    });

    const header = document.querySelector('.header-wrapper');

    function updateHeader() {
        if (window.scrollY > 50) {
            header.classList.add('header-wrapper--fixed');
            document.body.classList.add('header-fixed');
        } else {
            header.classList.remove('header-wrapper--fixed');
            document.body.classList.remove('header-fixed');
        }
    }

    window.addEventListener('scroll', updateHeader);
    updateHeader();
}